import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { ProjectService } from './project.service';
import { ApiInit } from '../utils/api-init';
import { CurrentWhiteLabelApplication } from '../utils/current-white-label-application';

@Injectable({
  providedIn: 'root',
})
export class ProjectResolver implements Resolve<any> {
  constructor(
    private projectService: ProjectService,
    private apiInit: ApiInit,
    private app: CurrentWhiteLabelApplication
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const slug = this.app.isProjectApp()
      ? this.app.getProjectAppSlug()
      : route.paramMap.get('slug');
    if (slug) {
      this.apiInit.watch(async () => {
        this.projectService.loadProject(slug);
      });
    }
    return of(null);
  }
}
